import Mapper from "../../../../utils/mapper";
import Export from "../../../../utils/exportExcel";
import { format } from "rut.js";
import { config } from "../../../../utils/config";
import { institucionFinanciera, institucionFinancieraForm, institucionFinancieraRequest } from "../models/institucionFinanciera";
import { actualizarInstitucionService, crearInstitucionService } from "../service/servicesInstitucionFinanciera";

export function useInstitucion() {

    const save = async (data: institucionFinancieraForm, dataediting: institucionFinanciera | undefined) => {

        let dataRequest: institucionFinancieraForm = {
            nombre: data.nombre.trim(),
            rut: format(data.rut, { dots: false }),
            activo: data.activo,
        };

        if (dataediting) {
            return await actualizarInstitucionService(dataRequest);
        }
        else{
            return await crearInstitucionService(dataRequest);
        }

        
    }

    function exportExcelOld(data: institucionFinanciera[]) {
        const headers = [
            [
                'Nombre',
                'Rut',
                'Estado'
            ],
        ]
        const dataExport = data.map((row: institucionFinanciera) => ({
            'Nombre': row.nombre,
            'Rut': row.rut,
            'Estado': row.activo ? 'Activo' : 'Inactivo'
        }));

        return Export({
            dataSource: dataExport,
            fileName: Mapper.ToNombreArchivoExport('INSTITUCIONES'),
            headers: headers,
        })
    }

    return {
        save,
        exportExcelOld
    }
}
